import { Button } from 'antd';
import React, { useCallback } from 'react';
import SankeyIcon from '@src/icons/sankey.svg';
import { useHistory } from 'react-router-dom';
/**
 * Drill down to sankey page
 */
const { baseUrl } = window.conviva;
export const DrillDownToSankey: React.FC<{ dimension: string; rowData: object }> = ({
  dimension,
  rowData,
}) => {
  const history = useHistory();
  const handleActions = useCallback(() => {
    history.push(`${baseUrl}/dashboard/sankey/${rowData[dimension]}`);
  }, [rowData, history, dimension]);

  return (
    <Button type="text" style={{ margin: '0 6px' }} icon={<SankeyIcon />} onClick={handleActions} />
  );
};
